var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.5C7.51472 5.5 5.5 7.51472 5.5 10C5.5 12.4853 7.51472 14.5 10 14.5C12.4853 14.5 14.5 12.4853 14.5 10C14.4974 7.51579 12.4842 5.50258 10 5.5ZM10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7C11.6569 7 13 8.34315 13 10C13 11.6569 11.6569 13 10 13ZM14.5 0.25H5.5C2.60179 0.2531 0.2531 2.60179 0.25 5.5V14.5C0.2531 17.3982 2.60179 19.7469 5.5 19.75H14.5C17.3982 19.7469 19.7469 17.3982 19.75 14.5V5.5C19.7469 2.60179 17.3982 0.2531 14.5 0.25ZM18.25 14.5C18.25 16.5711 16.5711 18.25 14.5 18.25H5.5C3.42893 18.25 1.75 16.5711 1.75 14.5V5.5C1.75 3.42893 3.42893 1.75 5.5 1.75H14.5C16.5711 1.75 18.25 3.42893 18.25 5.5V14.5ZM16 5.125C16 5.74632 15.4963 6.25 14.875 6.25C14.2537 6.25 13.75 5.74632 13.75 5.125C13.75 4.50368 14.2537 4 14.875 4C15.4963 4 16 4.50368 16 5.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.731d95487c7587d764ec7f22b10fc6d2.svg";
export { ForwardRef as ReactComponent };